import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

const FE_WEB_URL = 'https://app.tradiora.id';

function FinalCTA() {
  return (
    <section
      className="final-cta"
      style={{
        background: 'linear-gradient(135deg, #0b1120 0%, #0f1a3a 50%, #1a0f2e 100%)',
      }}
    >
      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            background: 'rgba(12,143,134,0.1)', border: '1px solid rgba(12,143,134,0.2)',
            borderRadius: 100, padding: '6px 20px',
            marginBottom: 24,
          }}>
            <Sparkles size={14} color="#0C8F86" />
            <span style={{ color: '#0C8F86', fontSize: 13, fontWeight: 600 }}>
              Mulai Perjalanan Anda
            </span>
          </div>

          <h2 style={{
            fontSize: 44,
            fontWeight: 700,
            color: '#fff',
            marginBottom: 16,
            letterSpacing: '-1.5px',
            lineHeight: 1.15,
          }}>
            Siap Menjadi Trader yang Lebih Baik?
          </h2>

          <p style={{
            fontSize: 18,
            color: 'rgba(255,255,255,0.55)',
            maxWidth: 540,
            margin: '0 auto 40px',
            lineHeight: 1.7,
          }}>
            Gabung bersama ribuan investor Indonesia yang belajar dan berkembang bersama Tradiora.
          </p>

          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href={FE_WEB_URL} className="final-cta__btn-primary">
              Daftar Gratis <ArrowRight size={18} />
            </a>
            <Link to="/pricing" className="final-cta__btn-secondary">
              Lihat Paket
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default FinalCTA;
